//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const role = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getRoles(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/role?query=${query}`,
        obj
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function getRoleList(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/role/role-list`,
        obj
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function createRole(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/role`, obj);
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function updateRole(values) {
    try {
      const obj = {
        method: "PUT",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/role`, obj);
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function screenviewdetail(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/role/get-view-screen?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


  async function getscreen() {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/role/get-screen`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }

  async function getuser(query) {
    try {
      const {searchValue, loyaltyId} = query;
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };  
      let res = await fetch(`${config.host}/cdr-panel/role/usersearch?searchValue=${searchValue}`,obj);
      let body = await res.json();
      return body;
    } catch (err) {}
  }

  async function assignUser(values) {
    try {
      const obj = {
        method: "PUT",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/role/assign-user`, obj);
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  return {
    getRoles,
    createRole,
    updateRole,
    screenviewdetail,
    getscreen,
    getuser,
    assignUser,
    getRoleList
  };
};

export default role;
